"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _cccisdFormik = require("cccisd-formik");
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _styleAssignmentcard = _interopRequireDefault(require("../../../Card/style-assignmentcard.css"));
var _SurveySelector = _interopRequireDefault(require("../SurveySelector"));
var _helpers = require("../../helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function DraggableCard(_ref) {
  var draggableId = _ref.draggableId,
    index = _ref.index,
    title = _ref.title,
    actions = _ref.actions,
    children = _ref.children;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
    draggableId: draggableId,
    index: index
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      ref: provided.innerRef
    }, provided.draggableProps, provided.dragHandleProps), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames2["default"])(_styleAssignmentcard["default"].cardWrapper, _defineProperty({}, _styleAssignmentcard["default"].expanded, isExpanded)),
      style: {
        marginTop: '1em'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _styleAssignmentcard["default"].header
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _styleAssignmentcard["default"].leftSide,
      onClick: function onClick() {
        return setIsExpanded(!isExpanded);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: [_styleAssignmentcard["default"].collapseArrow, isExpanded ? _styleAssignmentcard["default"].expanded : _styleAssignmentcard["default"].collapsed].join(' ')
    }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _styleAssignmentcard["default"].titleArea
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _styleAssignmentcard["default"].title
    }, title))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _styleAssignmentcard["default"].rightSide
    }, actions)), isExpanded && /*#__PURE__*/_react["default"].createElement("div", {
      className: _styleAssignmentcard["default"].content
    }, children)));
  });
}
function FormTimepoint(_ref2) {
  var surveyList = _ref2.surveyList,
    timepointNumber = _ref2.timepointNumber,
    removeTimepoint = _ref2.removeTimepoint,
    timepoint = _ref2.timepoint;
  var index = timepointNumber - 1;
  var title = "Timepoint ".concat(timepointNumber, " ").concat(timepoint.label ? "- ".concat(timepoint.label) : '');
  var actions = /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-danger",
    type: "button",
    onClick: function onClick() {
      return removeTimepoint();
    }
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null));
  return /*#__PURE__*/_react["default"].createElement(DraggableCard, {
    draggableId: "timepoint_".concat(index),
    index: index,
    title: title,
    actions: actions
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "timepoints[".concat(index, "].label"),
    component: _cccisdFormik.CccisdInput,
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Timepoint Label",
      tooltip: "The label for this timepoint."
    })
  })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "timepoints[".concat(index, "].surveys"),
    label: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Surveys",
      tooltip: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Select the default survey(s) for this timepoint."))
    })),
    component: _SurveySelector["default"],
    surveyList: surveyList
  }));
}
var _default = FormTimepoint;
exports["default"] = _default;